import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import {Fonts} from 'shared/constants/AppEnums';
import CurrencyStats from './CurrencyStats';

const Valuation = ({valuationData}) => {
  return (
    <Box>
      <Box
        component='h2'
        sx={{
          color: 'text.primary',
          textTransform: 'uppercase',
          fontSize: 16,
          mb: {xs: 4, sm: 4, xl: 6},
          fontWeight: Fonts.BOLD,
        }}
      >
        Current Valuation
      </Box>
      <Grid container spacing={{xs: 4, md: 8}}>
        <Grid item xs={12} sm={6}>
          <CurrencyStats
            icon={'/assets/images/euro.svg'}
            data={valuationData.inEUR}
            heading='Total Inventory (EUR)'
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <CurrencyStats
            icon={'/assets/images/rub.svg'}
            data={valuationData.inRUB}
            heading='Total Inventory (RUB)'
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Valuation;

Valuation.propTypes = {
  valuationData: PropTypes.object,
};
